
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M11.25 12a.75.75 0 01-.75.75h-7a.75.75 0 010-1.5h7a.75.75 0 01.75.75zm0 5a.75.75 0 01-.75.75h-7a.75.75 0 010-1.5h7a.75.75 0 01.75.75zm5.364.75a.75.75 0 00.577-.289l3.9-5a.75.75 0 00-1.182-.922l-3.33 4.27-1.505-1.791a.75.75 0 10-1.148.964l2.1 2.5a.75.75 0 00.588.268zM2.75 7c0 .414.336.75.75.75h17a.75.75 0 000-1.5h-17a.75.75 0 00-.75.75z","fill":"#A6ADB5"}}),_c('path',{attrs:{"d":"M14 6.25H3.5m0 0a.75.75 0 000 1.5h17a.75.75 0 000-1.5h-17zM11.25 12a.75.75 0 01-.75.75h-7a.75.75 0 010-1.5h7a.75.75 0 01.75.75zm0 5a.75.75 0 01-.75.75h-7a.75.75 0 010-1.5h7a.75.75 0 01.75.75zm5.364.75a.75.75 0 00.577-.289l3.9-5a.75.75 0 00-1.182-.922l-3.33 4.27-1.505-1.791a.75.75 0 10-1.148.964l2.1 2.5a.75.75 0 00.588.268z","stroke":"#A6ADB5","stroke-width":".57"}})])
          )
        }
      }
    